import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import api, { money, formatApiError } from "../lib/api";

function StockTab() {
  const [rows, setRows] = useState([]);
  const [draft, setDraft] = useState({});
  const load = () => api.get("/admin/stock").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async (row) => {
    try {
      await api.put("/admin/stock", { product_id: row.product_id, variation_id: row.variation_id, stock: parseInt(draft[row.variation_id] ?? row.stock) || 0 });
      toast.success("Estoque atualizado");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div className="border border-white/10 rounded-lg overflow-x-auto">
      <table className="w-full text-sm min-w-[680px]" data-testid="stock-table">
        <thead className="bg-white/5 text-zinc-400 text-xs uppercase tracking-wider">
          <tr>
            <th className="text-left px-5 py-3">Produto</th>
            <th className="text-left px-5 py-3">Variação</th>
            <th className="text-left px-5 py-3">SKU</th>
            <th className="text-left px-5 py-3">Estoque</th>
            <th className="px-5 py-3"></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.variation_id} className="border-t border-white/5" data-testid={`stock-row-${r.sku}`}>
              <td className="px-5 py-3 text-zinc-200">{r.product}</td>
              <td className="px-5 py-3 text-zinc-400">{r.variation}</td>
              <td className="px-5 py-3 text-zinc-500 font-mono text-xs">{r.sku}</td>
              <td className="px-5 py-3">
                <div className="flex items-center gap-2">
                  <Input type="number" min="0" className="w-24 bg-[#141414] border-white/10"
                    value={draft[r.variation_id] ?? r.stock}
                    onChange={(e) => setDraft({ ...draft, [r.variation_id]: e.target.value })}
                    data-testid={`stock-input-${r.sku}`} />
                  {(r.stock <= 3) && <span className={`text-[10px] uppercase tracking-wider ${r.stock === 0 ? "text-red-400" : "text-amber-400"}`}>{r.stock === 0 ? "zerado" : "baixo"}</span>}
                </div>
              </td>
              <td className="px-5 py-3 text-right">
                <Button size="sm" variant="outline" className="border-gold/40 text-gold hover:bg-amber-500/10"
                  onClick={() => save(r)} data-testid={`stock-save-${r.sku}`}>Salvar</Button>
              </td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={5} className="px-5 py-10 text-center text-zinc-600">Nenhum produto físico.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

function BestSellersTab() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/best-sellers").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div className="border border-white/10 rounded-lg overflow-x-auto">
      <table className="w-full text-sm min-w-[560px]" data-testid="best-sellers-table">
        <thead className="bg-white/5 text-zinc-400 text-xs uppercase tracking-wider">
          <tr>
            <th className="text-left px-5 py-3">#</th>
            <th className="text-left px-5 py-3">Produto</th>
            <th className="text-left px-5 py-3">Unidades vendidas</th>
            <th className="text-left px-5 py-3">Receita</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.name} className="border-t border-white/5" data-testid={`best-seller-row-${i}`}>
              <td className="px-5 py-3.5 text-gold font-mono">{i + 1}º</td>
              <td className="px-5 py-3.5 text-zinc-200">{r.name}</td>
              <td className="px-5 py-3.5 text-zinc-300">{r.qty}</td>
              <td className="px-5 py-3.5 text-gold">{money(r.revenue)}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={4} className="px-5 py-10 text-center text-zinc-600">Nenhuma venda confirmada ainda.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

export default function AdminStock() {
  return (
    <div data-testid="admin-stock">
      <h1 className="font-display text-3xl tracking-tight mb-10">Estoque & Vendas</h1>
      <Tabs defaultValue="estoque">
        <TabsList className="bg-white/5 mb-8">
          <TabsTrigger value="estoque" className="data-[state=active]:bg-gold data-[state=active]:text-black" data-testid="tab-stock">Estoque por variação</TabsTrigger>
          <TabsTrigger value="vendas" className="data-[state=active]:bg-gold data-[state=active]:text-black" data-testid="tab-best-sellers">Mais vendidos</TabsTrigger>
        </TabsList>
        <TabsContent value="estoque"><StockTab /></TabsContent>
        <TabsContent value="vendas"><BestSellersTab /></TabsContent>
      </Tabs>
    </div>
  );
}
